export default __webpack_public_path__ + "static/media/Medical & Healthcare.9152428b.jpg";